export default [
  // 学习中心
  {
    path: '/group/:groupID',
    component: () => import('@/views/pages/group/index.vue'),
    redirect: '/group/:groupID/course',
    children: [
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/pages/group/course.vue')
      },
      {
        path: 'contest',
        name: 'contest',
        component: () => import('@/views/pages/group/contest.vue')
      },
      // {
      //   path: 'video',
      //   name: 'video',
      //   component: () => import('@/views/pages/group/video.vue')
      // },
      // {
      //   path: 'summary',
      //   name: 'summary',
      //   component: () => import('@/views/pages/group/summary.vue')
      // },
      // {
      //   path: 'notification',
      //   name: 'notification',
      //   component: () => import('@/views/pages/group/notification.vue')
      // },
      // {
      //   path: '',
      //   name: 'catalogue',
      //   component: () => import('@/views/pages/group/catalogue.vue')
      // },
      // {
      //   path: 'exam',
      //   name: 'exam',
      //   component: () => import('@/views/pages/group/exam.vue')
      // }
    ]
  },
]
